import { isNumber, MONTHS } from 'lib/utils'

export const getAnswer = dataInfo => {
  const { type, answer: { notApplicable, data: info } } = dataInfo
  if (notApplicable) {
    return 'Not Applicable'
  } else if (type === 'AGE') {
    return info.age
  } else if (type === 'LOCATION') {
    if (info?.isForeignLocation) {
      return `${info.city}, ${info.state}, ${info.country}`
    }
    return `${info.city}, ${info.state}`
  } else if (type === 'LENGTH_OF_TIME') {
    return `${info.years} years and ${info.months} months`
  } else if (type === 'RADIO_YES_TEXT') {
    if (info.choice === 'YES') {
      return `Yes. ${info.choiceText} children`
    }
    return 'No'
  }  else if (type === 'RADIO_YES_NO') {
    if (info.choice === 'YES') {
      return 'Yes'
    }
    return 'No'
  } else {
    return info.text
  }
}

export const doReplace = (title, replaceOps, answers) => {
  replaceOps.forEach(itm => {
    const foundValue = answers.find(answer => answer.id === itm.textId)
    if (foundValue) {
      title = title.replace(itm.pattern, foundValue.answer.text)
    }
  })
  return title
}

export const checkValidation = (info, type) => {
  try {
    if (type === 'AGE' && info) {
      return (info.age && isNumber(info.age))
    } else if (type === 'LOCATION' && info) {
      if (info?.isForeignLocation) {
        return (info.city && info.city !== '' && info.state && info.state !== '' && info.country && info.country !== '')
      }
      return (info.city && info.city !== '' && info.state && info.state !== '')
    } else if (type === 'LICENSE' && info) {
      return (info.number && info.number !== '' && info.state && info.state !== '')
    } else if (type === 'LENGTH_OF_TIME' && info) {
      return (info.months && info.months !== '' && info.years && info.years !== '')
    } else if (type === 'SELECT' && info) {
      return (info.text && info.text !== '')
    } else if (type === 'STATE' && info) {
      return (info.state && info.state !== '')
    } else if (type === 'TEXTAREA' && info) {
      return (info.text && info.text !== '')
    } else if (['TEXT','NUMBER','AMOUNT','PHONE','SSN','EMAIL'].indexOf(type) >= 0 && info) {
      return (info.text && info.text !== '')
    } else if (type === 'RADIO' && info) {
      return (!!info.choice)
    } else if (type === 'RADIO_YES_NO' && info) {
      return (!!info.choice)
    } else if (type === 'RADIO_YES_TEXT' && info) {
      if (!info.choice) return false
      if (info.choice === 'YES' && (!info.choiceText || info.choiceText === '')) return false
      return true
    } else if (type === 'CALLOUT') {
      return true
    } else if (type === 'ADDRESS') {
      return (
        info && 
        info.address && info.address !== '' &&
        info.city && info.city !== '' &&
        info.state && info.state !== '' &&
        info.zip && info.zip !== ''
      )
    } else if (type === 'PLACES_ADDRESS') {
      const data = info?.address?.data
      if (!data) return false
      return (
        data && 
        data.address && data.address !== '' &&
        data.city && data.city !== '' &&
        data.state && data.state !== '' &&
        data.zip && data.zip !== ''
      )
    } else if (['NAME','FULLNAME'].indexOf(type) >= 0 && info) {
      return (
        info && 
        info.nameFirst && info.nameFirst !== '' &&
        info.nameLast && info.nameLast !== ''
      )
    } else if ((type === 'DOB' || type === 'DATE') && info) {
      return (
        info &&
        info.month !== '' && 
        info.day !== '' && 
        info.year !== ''
      )
    }
    return false
  } catch(e) {
    console.error(e)
    return false
  }
}

export const validateQuestionAnswer = (question, info, notApplicable = false) => {
  if (notApplicable) return { text: 'Not Applicable', data: { text: 'Not Applicable' }, notApplicable: true }
  if (question.type === 'AGE') {
    if (checkValidation(info, question.type)) {
      return { text: `${info.age}`, data: info, notApplicable: false }
    }
    throw new Error('Please enter a valid option for the age.')
  } else if (question.type === 'LOCATION') {
    if (checkValidation(info, question.type)) {
      if (info?.isForeignLocation) {
        return { text: `${info.city}, ${info.state}, ${info.country}`, data: info, notApplicable: false }
      }
      info.country = 'United States'
      return { text: `${info.city}, ${info.state}`, data: info, notApplicable: false }
    }
    throw new Error('Please enter valid options for City and State.')
  } else if (question.type === 'LICENSE') {
    if (checkValidation(info, question.type)) {
      return { text: `${info.number} - ${info.state}`, data: info, notApplicable: false }
    }
    throw new Error('Please enter valid options for License Number and State.')
  } else if (question.type === 'LENGTH_OF_TIME') {
    if (checkValidation(info, question.type)) {
      return { text: `${info.years} years and ${info.months} months`, data: info, notApplicable: false }
    }
    throw new Error('Please enter valid options for Months and Years.')
  } else if (question.type === 'RADIO') {
    if (checkValidation(info, question.type)) {
      return { text: info.choice, data: info, notApplicable: false }
    }
    let error = 'Please choose an option and try again.'
    if (info && info.choice) error = 'Follow up answer is invalid, please try again.'
    throw new Error(error)
  } else if (question.type === 'RADIO_YES_TEXT') {
    if (checkValidation(info, question.type)) {
      if (info.choice === 'YES') {
        return { text: `Yes. ${info.choiceText}`, data: info, notApplicable: false }
      } else {
        return { text: `No`, data: info, notApplicable: false }
      }
    }
    let error = 'Please choose an option and try again.'
    if (info && info.choice) error = 'Follow up answer is invalid, please try again.'
    throw new Error(error)
  } else if (question.type === 'RADIO_YES_NO') {
    if (checkValidation(info, question.type)) {
      if (info.choice === 'YES') {
        return { text: `Yes`, data: info, notApplicable: false }
      } else {
        return { text: `No`, data: info, notApplicable: false }
      }
    }
    let error = 'Please choose an option and try again.'
    if (info && info.choice) error = 'Follow up answer is invalid, please try again.'
    throw new Error(error)
  } else if (question.type === 'ADDRESS') {
    if (checkValidation(info, question.type)) {
      return { text: `${info.address}, ${info.city}, ${info.state} ${info.zip}`, data: info, notApplicable: false }
    }
    throw new Error('Please enter an address and zip code and try again.')
  } else if (question.type === 'PLACES_ADDRESS') {
    if (checkValidation(info, question.type)) {
      const { data, addressObject } = info.address
      return { text: addressObject.label, data: data, addressObject, notApplicable: false }
      // console.log('itm.answer: ', itm.answer)
      // return { text: `${info.address}, ${info.address2}, ${info.city}, ${info.state} ${info.zip}`, data: info, notApplicable: false }
    }
    throw new Error('Please enter an address and zip code and try again.')
  } else if (['PHONE','SSN'].indexOf(question.type) >= 0) {
    if (checkValidation(info, question.type)) {
      return { text: info.text, data: info, notApplicable: false }
    }
    throw new Error('Please enter both a vald social security number and try again.')
  } else if (question.type === 'NAME') {
    if (checkValidation(info, question.type)) {
      return { text: `${info.nameFirst}, ${info.nameLast}`, data: info, notApplicable: false }
    }
    throw new Error('Please enter both a first and last name and try again.')
  } else if (question.type === 'FULLNAME') {
    if (checkValidation(info, question.type)) {
      return { text: `${info.nameFirst} ${info.nameMiddle || ''} ${info.nameLast}`, data: info, notApplicable: false }
    }
    throw new Error('Please enter both a first and last name and try again.')
  } else if (question.type === 'SELECT') {
    if (checkValidation(info, question.type)) {
      return { text: info.text, data: info, notApplicable: false }
    }
    throw new Error('Please choose an option, and try again.')
  } else if (question.type === 'STATE') {
    if (checkValidation(info, question.type)) {
      return { text: info.state, data: info, notApplicable: false }
    }
    throw new Error('Please choose a state, and try again.')
  } else if (['DATE','DOB'].indexOf(question.type) >= 0) {
    if (checkValidation(info, question.type)) {
      const month = MONTHS.find(itm => itm.value === info.month)
      return { text: `${month.label} ${info.day}, ${info.year}`, data: info, notApplicable: false }
    }
    throw new Error('Please enter both a date and try again.')
  } else if (question.type === 'CALLOUT') {
    return { text: true, data: { text: true }, notApplicable: false }
  } else {
    if (checkValidation(info, question.type)) {
      return { text: info.text, data: info, notApplicable: false }
    }
    throw new Error('This answer cannot be blank.')
  }
}
